const C = require("../constants");

const openModalProductStock = modal => {
    return {
        type: C.PRODUCTS_STOCK_MODAL,
        modal
    }
};

export {openModalProductStock};


// WEBPACK FOOTER //
// ./src/actions/ModalProductStockActions.js